// extracted by mini-css-extract-plugin
export default {"serverError":"wcmNFhfapH0wa_8DJq_F"};